export const BASE = {
  name: 'profile',
  path: '/profile',
} as const;

export const NOTIFICATIONS = {
  name: 'profile.notifications',
  path: `${BASE.path}/notifications`,
} as const;

export const PASSWORD = {
  name: 'profile.password',
  path: `${BASE.path}/password`,
} as const;

export const EMAIL = {
  name: 'profile.email',
  path: `${BASE.path}/email`,
} as const;

export const DETAILS = {
  name: 'profile.details',
  path: `${BASE.path}/details`,
} as const;

export const REFERRALS = {
  name: 'profile.referrals',
  path: `${BASE.path}/referrals`,
} as const;

export const SIGN_IN_ACTIVITY = {
  name: 'profile.sign-in-activity',
  path: `${BASE.path}/sign-in-activity`,
} as const;

export const LANGUAGE = {
  name: 'profile.language',
  path: `${BASE.path}/language`,
} as const;
